export const WORKBENCH_TABSETS: Record<string, string[]> = { dataSources: ['connections', 'agents'] };
export const WORKBENCH_SCHEMA_VERSION = 3;
